import React from "react";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import Button from "@components/Button/Button";
import Subheader from "@components/Subheader/Subheader";
import PageLayout from "@layouts/PageLayout";
import { useAuthStore } from "@persisted-state/auth/auth.store";
import { searchFottServices } from "@services/terminalServicesApi";
import { useQuery } from "@tanstack/react-query";
import { paths } from "@utils/navigation";
import { checkPermission } from "@utils/user-permissions";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import FottServicesGrid from "./grid/FottServicesGrid.tsx";

const LANG_BASE = "terminal-services.fott-services";
const TEST_ID_BASE = "fott-services";

const FottServicesContainer: React.FC = () => {
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();
  const { user, userActionPermissions } = useAuthStore();
  const dir = i18n.language === "ar" ? "rtl" : "ltr";
  const isCustomer = user?.roles.includes("customer") ?? false;
  const canRequestFottService =
    isCustomer && checkPermission(userActionPermissions, "canRequestFottService");
  const title = t(`${LANG_BASE}.title`);

  useQuery({
    queryKey: ["fott-services-preview"],
    queryFn: () =>
      searchFottServices({
        page: 1,
        pageSize: 10,
        body: {},
      }),
  });

  return (
    <PageLayout dir={dir}>
      <Subheader
        testId={`${TEST_ID_BASE}-subheader`}
        subtitle={t("terminal-services.title")}
        title={
          <div className="flex items-end justify-between w-full">
            <span>{title}</span>

            {canRequestFottService && (
              <Button
                type="button"
                variant="contained"
                color="primary"
                testId={`${TEST_ID_BASE}-request-button`}
                label={
                  <span className="text-sm font-medium flex items-center gap-2">
                    <AddCircleOutlineIcon fontSize="small" />
                    {t(`${LANG_BASE}.request-new-service`)}
                  </span>
                }
                sx={{ textTransform: "none", height: "40px", minHeight: "40px" }}
                onClick={() =>
                  navigate(
                    `/${paths.terminalServices.index}/${paths.terminalServices.requestFottService}`,
                  )
                }
              />
            )}
          </div>
        }
      />

      <div className="pt-8 pb-8 px-24 flex flex-col gap-6">
        <FottServicesGrid />
      </div>
    </PageLayout>
  );
};

export default FottServicesContainer;
